// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"winners__wrapper__Uq7an","title":"winners__title__rVTke","winnersText":"winners__winnersText__1dgKn"};